module.exports = __webpack_public_path__ + "img/Sistema-Mobile-Celular-Pizzaria.cc5e1c8a.jpg";